import { log } from "@app/app/services/log";

import { TCoreConfig } from "../types/core";

const DEBUG_KEY = "ibe-debug";

/**
 * Loader for debug configuration.
 * Reads configuration json from localStorage or other debug sources.
 */
export function loadDebugConfig(envConfig: TCoreConfig): Record<string, unknown> {
    loadDebugTools(envConfig);
    try {
        const debugDataRaw = localStorage.getItem(`${envConfig.globalVendorNamespace}-${DEBUG_KEY}`);
        const debugDataExists = debugDataRaw !== null;
        const debugData = debugDataExists ? JSON.parse(debugDataRaw) : {};

        if (debugDataExists) {
            log.warn("Debug config loaded:", debugData);
        }

        return debugData;
    } catch (error) {
        log.error("Error loading debug config:", error);
        return {};
    }
}

/**
 *  Debug tools bound to the window for development purposes
 *  Might be removed in production or hidden
 */

function printDebugConfig() {
    const debugConfig = localStorage.getItem(`${envConfigHolder.globalVendorNamespace}-${DEBUG_KEY}`);
    console.log(debugConfig);
}

function setDebugConfig(config: Record<string, unknown>) {
    localStorage.setItem(`${envConfigHolder.globalVendorNamespace}-${DEBUG_KEY}`, JSON.stringify(config));
    console.log("Debug config set, refresh the page to see the changes");
}

function resetDebugConfig() {
    localStorage.removeItem(`${envConfigHolder.globalVendorNamespace}-${DEBUG_KEY}`);
    console.log("Debug config reset, refresh the page to see the changes");
}

let envConfigHolder: TCoreConfig;
function loadDebugTools(envConfig: TCoreConfig) {
    envConfigHolder = envConfig;
    window[envConfigHolder.globalVendorNamespace].debug = {
        print: printDebugConfig,
        set: setDebugConfig,
        reset: resetDebugConfig,
    };
}
